// src/utils/logExport.js

/**
 * Log an export event for audit or analytics purposes.
 * Replace with real API call if needed.
 */
export function logExportEvent(details) {
  console.log('Export logged:', details);
}
